import React, { useState, useEffect, useRef } from "react";
import Grid from "@mui/material/Grid2";

import { 
  Campaign, 
  CampaignNote, 
} from "@dndModels";

import EditableLabel from "@components/input/strings/EditableLabel";
import DescriptionBox from "@dndComponents/DescriptionBox";
import DeleteButton from "@components/input/buttons/DeleteButton";
import ModalOrDrawer from "@components/display/ModalOrDrawer";
import DandDAPI from "@dndUtilities/system_api";

interface Props {
  obj: Campaign;
  note: CampaignNote;
  onDelete: () => void;
}

const api = DandDAPI.getInstance();

export default function CampaignNoteInput({ obj, note, onDelete }: Props) {
  const [reloading, setReloading] = useState(false);
  // const [processing, setProcessing] = useState(false);
  const [ping, setPing] = useState(false);
  const [open, setOpen] = useState(note.name.length === 0);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const renderExtras = () => {
    return (
      <ModalOrDrawer
        open={open}
        onClose={() => { setOpen(false); }}>
        { renderInputControls() }
      </ModalOrDrawer>
    )
  }

  const renderInputControls = () => {
    return (
      <Grid container spacing={0} direction="row">
        <Grid size={10}>
          <EditableLabel
            name="Name"
            value={note.name}
            fontSize={24}
            onChange={ async (changed: string) => {
              note.name = changed;
              api.upsertObject("campaign_note", note);
              setPing(!ping);
            }}
          />
        </Grid>
        <Grid size={2}>
          <DeleteButton
            onClick={onDelete}
          />
        </Grid>
        <Grid size={12}>
          <DescriptionBox
            name="Details"
            value={note.notes}
            onChange={(changed: string) => {
              note.notes = changed;
              api.upsertObject("campaign_note", note);
              setPing(!ping);
            }}
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      <Grid className="header clickable" onClick={() => setOpen(true) }>{ note.name }</Grid>
      { renderExtras() }
    </>
  );
}
